// shared variables for js and css
import * as SHARED from '../shared-variables'

// helpers
import {Scroller} from 'gi-js-base/src/utils/dom'
import {DeviceInfo} from 'gi-js-base/src/utils/device'

// icons
import {Icon, IconManager} from 'gi-feature-icons'
// object-fit polyfill
import ObjectFit from 'gi-feature-object-fit'

// import Slick from 'slick-carousel'


// site features
// import WowJsMin from './features/vendor/wow.min'
import WowJs from './features/vendor/wow'
import Pulsate from './features/vendor/jquery.pulsate'
import Navigation from './features/navigation'
import Events from './features/events'
import Accordion from './features/accordion'
import Modernizr from './features/vendor/modernizr.min'
// import ModernizrCustom from './features/vendor/modernizrCustom.min'
// import Classie from './features/classie'
// import Overlay from './features/overlay'
import Test from './features/test'
import MovingBackground from './features/movingBackground'
import ScrollToElement from './features/scrollToElement'
import ModalJobs from './features/modalEvents'
import MobileNavigation from './features/mobileNavigation'
import Tilt from './features/vendor/tilt'

// import Slick from './features/slick'

import Flickity from './features/vendor/flickity.pkgd'

import Howler from './features/howler'
import HowlerPlugin from './features/howlerplugin'
import HowlerSetup from './features/howlersetup'


// init WOW

var app = {

  ui: {
    $header: document.querySelector('.layout-header'),
    $footer: document.querySelector('.layout-footer')
  },

  icons: null,
  scroll: null,
  scrollWithHeaderOffset: null,
  device: null,

  init() {
    // this.initWow().initIcons().initScroller().initDeviceInfo().addFeatures().initFeatures()
    this.initIcons().initScroller().initDeviceInfo().addFeatures().initFeatures()
  },

  addFeatures() {
    // object-fit-images polyfill feature
    gi.features.add('fit', ObjectFit)
    gi.features.add('fit-watch', ObjectFit, {watchMQ: true})

    // site features
    // gi.features.add('quote', RandomQuote, {count: 1})

    return this
  },

  initFeatures() {
    gi.features.init(document.body)
    return this
  },

  // initWow() {
  //
  //   var wow = new WOW( { mobile: false, } );
  //   wow.init();
  //
  //   return this
  // },


  initIcons() {
    this.icons = new IconManager({svgJsonFile: 'assets/icons.json', svgSpriteFile: 'assets/icons.svg'})

    this.icons.injectSprite(() => {
      this.icons.loadData(() => {
        gi.features.add('icon', Icon, {manager: this.icons})
        gi.features.init(document.body, 'icon')
      })
    })

    return this
  },

  initScroller() {
    this.scroll = new Scroller()

    // scroller with header as offset
    this.scrollWithHeaderOffset = new Scroller({
      offsetY: this.ui.$header.offsetHeight + 20
    })

    return this
  },

  initDeviceInfo() {
    this.device = new DeviceInfo({
      breakpoints: {
        tiny: SHARED['break-tiny'],
        small: SHARED['break-small'],
        medium: SHARED['break-medium'],
        large: SHARED['break-large'],
        huge: SHARED['break-huge'],
        full: SHARED['break-full']
      }
    })

    return this
  }

}

app.init()



// WEBPACK FOOTER //
// ./assets/js/main.js